import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { take } from 'rxjs';

import { SsoExchangeFailure, SsoExchangeRequest, SsoExchangeSuccess } from '../../../store/auth/auth.actions';
import { withBrandName } from '../../../core/config/branding';

@Component({
  selector: 'app-sso-login',
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './sso-login.html',
  styleUrl: './sso-login.scss',
})
export class SsoLogin {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly store = inject(Store);
  private readonly actions$ = inject(Actions);

  protected readonly status = signal<'loading' | 'error'>('loading');
  protected readonly message = signal('Logging you in...');
  protected readonly title = withBrandName('Login');

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token')?.trim() ?? '';
    if (!token) {
      this.fail('Invalid SSO login link.');
      return;
    }

    this.store.dispatch(SsoExchangeRequest({ payload: { login_token: token } }));

    this.actions$.pipe(ofType(SsoExchangeSuccess), take(1)).subscribe(() => {
      void this.router.navigate(['/']);
    });

    this.actions$.pipe(ofType(SsoExchangeFailure), take(1)).subscribe(({ error }) => {
      this.fail(error || 'We could not complete the SSO login.');
    });
  }

  protected goToLogin(): void {
    void this.router.navigate(['/auth/login']);
  }

  private fail(message: string): void {
    this.status.set('error');
    this.message.set(message);
  }
}
